import CreateDrive from "../../../../football/rules/general/drives/create-drive";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

export default class FlagCreateDrive extends CreateDrive {
    kickoffContextChanges(gameContext) {
        // The base hook arms the PAT for a drive opened straight after a
        // kickoff-return touchdown. Only reachable when kickoffs are enabled.
        if (!isKickoffEnabled(gameContext)) return;

        return super.kickoffContextChanges(gameContext);
    }
}
